module.exports = __webpack_public_path__ + "img/symbol_5.eec2934b.png";